import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { Lead } from '../model/lead';
import { Observable } from 'rxjs/Observable';

import { of } from 'rxjs/observable/of'

declare const fbq: any;

@Injectable()

export class LeadserviceService {

  public static iddem: number;
  public static ip;

  constructor(private http: HttpClient) {

    // this.http.get("https://freegeoip.net/json/?callback").subscribe(data => LeadserviceService.ip = data['ip']);
  }

  public getIddem(): number {
    return LeadserviceService.iddem;
  }

  public setIddem(iddem: number) {
    LeadserviceService.iddem = iddem;
  }

  public sendleads(lead: Lead, point: string): Observable<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var ip = "";


    if (this.getIddem() == null || this.getIddem() == 0) { this.setIddem(50); }
    var url = "https://leadsapi.fastcall.info/api/FA?cognome=" + lead.cognome + "&nome=" + lead.nome + "&telefono=" + lead.telefono + "&email=" + lead.email + "&iddem=" + this.getIddem() + "&cap=" + lead.cap + "&note=" + lead.Note + "&ip=" + LeadserviceService.ip + "&DataAppuntamento=" + lead.dataappuntamento+"&Point="+point
      +"&ConsensoComunicazioniPromozionali=" + (lead.ConsensoComunicazioniPromozionali ? 1 : 0) + "&ConsensoCessioneSocietaPartner=" + (lead.ConsensoCessioneSocietaPartner ? 1 : 0) + "&ConsensoCessioneTerzi=" + (lead.ConsensoCessioneTerzi ? 1 : 0) + "&Url=" + lead.Url;

    console.log(url);
    var ret = this.http.post<boolean>(url, "test", httpOptions);
    fbq('track', 'Lead');
    return ret;

  }

  public sendleadsNotObserver(lead: Lead, point: string): boolean {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var ip = "";

    var fatto = false;
    var stato = false;
    if (this.getIddem() == null || this.getIddem() == 0) { this.setIddem(50); }
    var url = "https://leadsapi.fastcall.info/api/FA?cognome=" + lead.cognome + "&nome=" + lead.nome + "&telefono=" + lead.telefono + "&email=" + lead.email + "&iddem=" + this.getIddem() + "&cap=" + lead.cap + "&note=" + lead.Note + "&ip=" + LeadserviceService.ip + "&DataAppuntamento=" + lead.dataappuntamento + "&Url=" + lead.Url;

    console.log(url);
    this.http.post<boolean>(url, "test", httpOptions)
      .subscribe(data => {
        fatto = true;
        stato = data; console.log(data);
      }, e => { console.log(e); stato = false; fatto = true; });

    while (!fatto) {

    }
    return stato;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/leadservice.service.ts